import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine clsx + tailwind-merge for conditional className composition.
 * The only utility actually used by the landing-only application.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
